import classNames from 'classnames';

import { UseFormRegisterReturn } from 'react-hook-form';

import styles from './styles.module.scss';
const { input_container, input_field, input_label, error, has_error } = styles;

type Props = {
  label: string;
  name: string;
  type?: string;
  placeholder?: string;
  required?: boolean;
  defaultInputValue?: string;
  register: UseFormRegisterReturn;
  showError?: boolean;
  errorMsg?: string;
};

const TextInput = ({
  label,
  name,
  type = 'text',
  placeholder = '',
  required = false,
  defaultInputValue = '',
  register,
  showError = false,
  errorMsg
}: Props) => {
  return (
    <div className={input_container}>
      {label && (
        <label className={input_label} htmlFor={name}>
          {label}
        </label>
      )}
      <input
        id={name}
        className={classNames(input_field, { [has_error]: errorMsg && showError })}
        type={type}
        required={required}
        placeholder={placeholder}
        defaultValue={defaultInputValue}
        {...register}
      />
      {errorMsg && showError && <div className={error}>{errorMsg}</div>}
    </div>
  );
};

export default TextInput;
